module.exports = __webpack_public_path__ + "images/feature/20161107_03-80525f3f65697a21b515b99dd420d4ff.jpg";